import React, { useState, useEffect } from 'react';
import './AppDownloadPopup.css';

const AppDownloadPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="app-download-popup">
      <div className="popup-content">
        <button className="close-button" onClick={handleClose}>×</button>
        <img src="/app-preview.PNG" alt="App Preview" className="app-preview-image" />
        <h3 className="app-modal-title">Pod Recs</h3>
        <p className="app-modal-subtitle">All the recs - now with descriptions</p>
        <div className="app-buttons">
          <a href="https://apps.apple.com/us/app/pod-recs/id6745399612" className="app-store-button">
            <img src="/app-store.svg" alt="Download on the App Store" className="app-store-icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadPopup; 